import { render } from "./ReadyForPickup.vue?vue&type=template&id=8cf5e470"
import script from "./ReadyForPickup.vue?vue&type=script&lang=js"
export * from "./ReadyForPickup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__